<template>

  <div class="home-wrap">

    <div id="demo" class="carousel slide" data-ride="carousel">

      <!-- 指示符 -->
      <ul class="carousel-indicators">
        <li data-target="#demo" v-for="(image, index) in lb" :data-slide-to="index"
            :class="index ==0?'active':''"></li>
      </ul>

      <!-- 轮播图片 -->
      <div class="carousel-inner">
        <div :class="index ==0 ?'carousel-item active':'carousel-item '" v-for="(image, index) in lb">
          <van-image fit="cover" width="100%" height="calc(100vw * 270 / 800)" :src="image.img"/>
        </div>

      </div>

      <!-- 左右切换按钮 -->
      <a class="carousel-control-prev" href="#demo" data-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </a>
      <a class="carousel-control-next" href="#demo" data-slide="next">
        <span id="sddfsd" class="carousel-control-next-icon"></span>
      </a>

    </div>

    <!--  科技  -->
    <div class="zoujinwomen">
      <label class="server-title"> -- 走进碳索 ABOUT US -- </label>
      <div class="wm-desc-wrap">
        <div class="wm-left-wrap">
          <div class="wmtitle">碳索科技</div>
          <!--          <p>-->
          <!--            碳索（杭州）能源环境科技有限公司位于风景优美、交通便利的高端科技研发集聚地——浙江省杭州市青山湖科技城，毗邻浙江大学青山湖能源研究基地、香港大学浙江科学技术研究院等高等学府。公司以专业、专注的理念持续深耕清洁低碳能源体系建设，先后与浙江大学、清华大学、东南大学、北京化工大学、四川大学、天津大学等17个院所开展深度合作，在碳减排、大宗工业固废处理、废气治理等面取得突破进展，并致力于开展节能环保新技术产、学、研一体化项目建设。</p>-->
          <!--          <p>公司以“瞄准能源学科技术前沿-->
          <!--            提供低碳环保解决方案”为宗旨，紧盯行业发展前沿并积极对接企业技术需求，以自主核心研发团队为基础，并紧密依托国内高校及院所研究资源，以专业、成熟的产学研结合模式，为低碳环保、绿色循环发展提供技术动力。目前核心技术研发团队有教授、研究员、教授级高级工程师及博士后、博士、硕士20余人，相关配套专业工程设计人员、工程技术人员30余人，研发团队取得并可授权使用专利30余项。公司对接各大高校、科研院所和国内各类型企业，专业从事技术咨询、工艺开发、工艺包开发、新工艺新技术新工程项目初步设计、新装置设计及建设、EPC一体化项目建设、技术升级改造及成果推广及转化等工作。</p>-->

          <div id="pp" class="js-pp">


          </div>
        </div>
        <div style="width: 40px"></div>
        <van-image width="366px" height="290px" :src="require('../../../assets/imgs/zoujintansuo-c.png')"/>
      </div>

    </div>
    <!--  业务范围  -->
    <div class="ywfanwei">
      <label class="server-title"> -- 业务范围 SERVICE CONTENT -- </label>
      <div class="tab-wrap">

        <div class="tab-item-wrap">
          <div class="img-wrap">
            <van-image fit="cover" height="100%" :src="require('../../../assets/imgs/jszx-icon.png')"/>
          </div>
          <label class="tab-txt">技术咨询</label>
        </div>
        <div class="tab-item-wrap">
          <div class="img-wrap">
            <van-image fit="cover" height="100%" :src="require('../../../assets/imgs/gykf-ic.png')"/>
          </div>
          <label class="tab-txt">工艺开发</label>
        </div>
        <div class="tab-item-wrap">
          <div class="img-wrap">
            <van-image fit="cover" height="100%" :src="require('../../../assets/imgs/zszz-ic.png')"/>
          </div>
          <label class="tab-txt">中试及示范装置EPC</label>
          <!--          <label style="font-size: 14px;color: #333333">(含示范装置)</label>-->
        </div>
        <div class="tab-item-wrap">
          <div class="img-wrap">
            <van-image fit="cover" height="100%" :src="require('../../../assets/imgs/ythjs-ic.png')"/>
          </div>
          <label class="tab-txt">CCUS全流程工程建设</label>
        </div>
        <div class="tab-item-wrap">
          <div class="img-wrap">
            <van-image fit="cover" height="100%" :src="require('../../../assets/imgs/jssjgz-ic.png')"/>
          </div>
          <label class="tab-txt">技术升级改造</label>
        </div>
        <div class="tab-item-wrap">
          <div class="img-wrap">
            <van-image fit="cover" height="100%" :src="require('../../../assets/imgs/cgtg-ic.png')"/>
          </div>
          <label class="tab-txt">成果推广</label>
        </div>
      </div>
    </div>
    <!--  核心技术  -->
    <div class="hexinkeji">
      <label class="server-title"> -- 核心技术 KEY TECHNOLOGIES -- </label>
      <div class="hexin-item-wrap">
        <div class="itm-wrap" v-for="(iii, index) in hexinList" @click="hexinItem($event,iii)">

          <div class="inner-wrap">
            <div class="hxiitem-img-wrap">
              <img class="hxiitem-img" :src="iii.head_img"/>
            </div>

            <div class="hxitm-txt">{{ iii.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--  工程案例  -->
    <div class="gongchenganli">
      <label class="server-title"> -- 工程案例 ENGINEERING CASE -- </label>

      <div class="gongchengli-wrap">

        <div class="gongchengliitem-wrap">

          <div class="gongc-iiii-ww" v-for="(iii, index) in gcal" @click="anliItem($event,iii)">

            <div class="inner-gongc-wrap">

              <div class="gongc-img-wrap">
                <img class="gongc-img" :src="iii.head_img">
              </div>
              <div class="info-wwww">
                <div class="gongc-title">{{ iii.title }}</div>
                <div class="rich-gongc">{{ iii.subtitle }}</div>
                <!--                <div class="gongcheng-dec">{{ iii.time }}</div>-->
              </div>
            </div>
          </div>

        </div>

      </div>

      <div class="more-txt" @click="goAnli">查看更多>></div>
    </div>

    <!--  新闻资讯  -->
    <div class="xinwenzixun">
      <label class="server-title"> -- 新闻资讯 NEWS INFORMATION -- </label>

      <div class="xinwen-item-wrap">

        <div class="xinwen-left-wrap">

          <div class="left-item-wrap" v-for="(item ,index) in xwzx" @click="xinwenItem($event,item)">

            <div class="inner-wrap">
              <div class="left-item-img-wra">
                <img class="left-item-img" :src="item.head_img">
              </div>

              <div class="left-item-info-wrap">

                <div class="left-item-name-txt">{{ item.title }}</div>
                <div class="left-item-desc-txt">{{ item.subtitle }}</div>
              </div>
            </div>
          </div>

        </div>

        <div class="xinwen-right-wrap">
          <div class="right-top-header">

            <img src="../../../assets/imgs/gsdt-ica.png" class="rrrr-img">

            <div class="rrrr-txt">
              公司动态
            </div>
          </div>
          <div class="gongsidongt-item-wrap" v-for="(item,index) in gsdt" @click="xinwenItem($event,item)">
            <div class="data-wrap">
              <div class="day-txt">{{ item.day }}</div>
              <div class="month-txt">{{ item.month }}</div>
            </div>
            <div class="rich-txt">{{ item.title }}</div>
          </div>

          <div class="ckmore-txt">
            <div class="a" @click="goNewsCenter">查看更多>></div>
          </div>
        </div>

      </div>

      <label class="server-title"> -- 联系我们 CONTACT US -- </label>

    </div>

    <!-- 联系我们   -->
    <div class="lxwomen">

      <div class="lxwo-wrap">

        <div class="lxwo-left-wrap">
          <div style="color: #666;font-size: 16px">地址：浙江省杭州市西湖区西溪路525号C楼5295室</div>
          <div style="margin-top: 20px;color: #666;font-size: 16px">电话：13023631525</div>
          <div style="margin-top: 20px;color: #666;font-size: 16px">邮箱：hztskj001@163.com</div>
        </div>
        <div id="container" class="lxwo-right-wrap"></div>
      </div>
    </div>

  </div>

</template>

<script>
import Vue from 'vue';
import {Swipe, SwipeItem} from 'vant';
import {Lazyload} from 'vant';
import {Image as VanImage} from 'vant';
import {Toast} from 'vant';
import $ from 'jquery'
import cache from '@/utils/cache'

Vue.use(Toast);
Vue.use(VanImage);

Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  name: "homeFragment",
  data() {

    return {
      iii: null
    }
  },
  computed: {
    hexinList() {
      return this.$store.state.hxjs
    },
    lb() {
      return this.$store.state.lb
    },
    xwzx() {
      return this.$store.state.xwzx
    },
    gcal() {
      let tmpG = []
      let gcal = this.$store.state.gcal
      for (let i = 0; i < 4 && i < gcal.length; i++) {
        tmpG.push(gcal[i])
      }
      return tmpG
    },
    gsdt() {
      return this.$store.state.gsdt
    },
  },
  mounted() {
    var map = new BMapGL.Map("container");
    map.enableScrollWheelZoom(true);
    // 创建地图实例
    var point = new BMapGL.Point(120.117246, 30.273219);
    // 创建点坐标
    map.centerAndZoom(point, 15);
    var marker1 = new BMapGL.Marker(new BMapGL.Point(120.117246, 30.273219));
// 在地图上添加点标记
    map.addOverlay(marker1);
    // this.getData()

    if (this.iii)
      clearInterval(this.iii)
    this.iii = setInterval(() => {
      $("#sddfsd").click()
      console.log('cccc')
    }, 5000)

    $("#pp").empty()
    $("#pp").append(this.$store.state.homeTs[0].detail);
  },
  destroyed() {
    clearInterval(this.iii)
    this.iii = null
  },
  methods: {

    goNewsCenter() {
      this.$router.push('/newsCenter')
    },
    goAnli() {
      this.$router.replace('/anliYj')
    },
    hexinItem(e, item) {//核心技术

      this.$router.push({
        path: '/hexinYw',
        name: 'hexinYwFragment',
        params: {
          item: item
        }
      })
    },
    anliItem(e, item) {//案例
      this.$router.push({
        path: '/anliYj',
        name: 'anliYjFragment',
        params: {
          item: item
        }
      })

    },
    xinwenItem(e, item) {//新闻
      console.log(item)
      const {href} = this.$router.resolve({
        path: '/newsDetail',
        name: 'newsDetailPage',
      });
      cache.setSession('itemnews', item)
      window.open(href, "_blank");

    },
  }
}
</script>

<style lang="less" scoped>

.home-wrap {
  width: 100%;
  display: flex;
  height: max-content;
  flex-direction: column;

  .carousel {
    width: 100vw;
    min-width: 1400px;
  }

  //.carousel-inner {
  //  width: 100%;
  //  height: calc(100vw * 270 / 800);
  //}

  .ywfanwei {
    background-color: #CDE5FF;
    width: 100vw;
    min-width: 1400px;
    display: flex;
    margin-top: -6px;
    flex-direction: column;
    align-items: center;

    .server-title {
      color: #333333;
      font-size: 18px;
      margin-top: 20px;
    }

    .tab-wrap {
      display: flex;
      margin-top: 10px;
      margin-bottom: 10px;
      width: 1350px;
      justify-content: space-between;

      .tab-item-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 190px;

        .img-wrap {
          width: 193px;
          height: 112px;
          text-align: center;
          overflow: hidden;
          border: #3FA8E6 4px solid;
          border-radius: 5px;
        }
      }

      .tab-txt {
        color: #333333;
        margin-top: 5px;
        font-size: 18px;
      }
    }
  }

  .zoujinwomen {
    background-color: white;
    width: 100vw;
    padding-bottom: 40px;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .server-title {
      color: #333333;
      font-size: 18px;
      margin-top: 10px;
    }

    .wm-desc-wrap {
      display: flex;

      .wm-left-wrap {
        display: flex;
        width: 910px;
        flex-direction: column;

        .wmtitle {
          color: #305C7E;
          font-size: 22px;
          font-weight: 600;
        }

        p {
          text-indent: 2em;
          font-size: 18px;
          color: #333333;
          margin-top: 10px;
          width: 100%;
        }

        .js-pp {
          width: 100%;
        }
      }

    }

  }

  .hexinkeji {
    background-image: linear-gradient(to bottom, #033474, #205980);
    width: 100vw;
    min-width: 1400px;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;

    .server-title {
      color: white;
      font-size: 18px;
      margin-top: 10px;
    }

    .hexin-item-wrap {
      display: flex;
      margin-top: 10px;
      flex-wrap: wrap;
      width: 1550px;

      .itm-wrap {
        display: flex;
        width: 33.33%;
        margin-top: 10px;
        flex-direction: column;
        align-items: center;

        .inner-wrap {
          display: flex;
          width: max-content;
          flex-direction: column;
          align-items: center;

          .hxiitem-img-wrap {
            width: 160px;
            height: 80px;
            border-radius: 5px;
            border: white solid 3px;
            overflow: hidden;
          }

          .hxiitem-img {
            width: 160px;
            height: 80px;
          }

          .hxitm-txt {
            font-size: 16px;
            color: white;
            max-width: 164px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-top: 5px;
          }
        }

        .inner-wrap:hover {
          cursor: pointer;

          .hxiitem-img {
            transition: All 0.4s ease-in-out;
            transform: scale(1.2);
          }

          .hxiitem-img-wrap {
            border: #FFE92C solid 3px;
          }

          .hxitm-txt {
            color: #FFE92C;
          }
        }
      }


    }

  }

  .gongchenganli {
    background-color: #E7E8E9;
    width: 100vw;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;

    .server-title {
      color: #333333;
      font-size: 18px;
      margin-top: 10px;
    }

    .gongchengli-wrap {
      display: flex;
      width: 1200px;

      .gongchengliitem-wrap {
        display: flex;
        width: 100%;
        flex-wrap: wrap;

        .gongc-iiii-ww {
          display: flex;
          margin-top: 16px;
          width: 50%;
          margin-bottom: 10px;

          .inner-gongc-wrap {
            display: flex;
            margin-right: 20px;

            .gongc-img-wrap {
              width: 160px;
              height: 100px;
              border-radius: 5px;
              line-height: 100px;
              border: white solid 3px;
              overflow: hidden;
            }

            .gongc-img {
              width: 160px;
              min-height: 100px;
            }

            .info-wwww {
              flex: 1;
              margin-left: 20px;
              display: flex;
              flex-direction: column;

              .gongc-title {
                color: #205980;
                font-size: 16px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }

              .rich-gongc {
                color: #565758;
                margin-top: 10px;
                font-size: 16px;
              }

              .gongcheng-dec {
                color: #565758;
                font-size: 16px;
              }
            }
          }

          .inner-gongc-wrap:hover {
            cursor: pointer;

            .gongc-img {
              transition: All 0.4s ease-in-out;
              transform: scale(1.2);
            }

            .inner-gongc-wrap {
              border: #205980 solid 3px;
            }

            .gongc-title {
              color: green;
            }
          }

        }

      }
    }

    .more-txt {
      font-size: 16px;
      color: #666666;
    }

    .more-txt:hover {
      cursor: pointer;
      color: #22B5A8;
      text-decoration: underline;
    }

  }

  .xinwenzixun {
    background-color: white;
    width: 100vw;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;

    .server-title {
      color: #333333;
      font-size: 18px;
      margin-top: 10px;
    }

    .xinwen-item-wrap {
      display: flex;
      width: 1200px;
      margin-top: 30px;

      .xinwen-left-wrap {
        display: flex;
        margin-right: 20px;
        flex-direction: column;

        .left-item-wrap {
          display: flex;
          flex-direction: row;
          padding-bottom: 10px;
          padding-top: 10px;
          align-items: center;
          margin-bottom: 10px;


          .inner-wrap {
            display: flex;
            flex-direction: row;
            margin-right: 20px;
            align-items: center;

            .left-item-img-wra {
              width: 160px;
              height: 100px;
              border-radius: 5px;
              line-height: 100px;
              border: white solid 3px;
              overflow: hidden;

              .left-item-img {
                width: 160px;
                min-height: 100px;
              }
            }

            .left-item-info-wrap {
              display: flex;
              flex-direction: column;
              margin-left: 20px;
              height: 100%;
              width: 590px;

              .left-item-name-txt {
                color: #205980;
                font-size: 16px;
              }

              .left-item-desc-txt {
                color: #58595A;
                font-size: 16px;
                margin-top: 10px;
              }

            }

          }

          .inner-wrap:hover {
            cursor: pointer;

            .left-item-img {
              transition: All 0.4s ease-in-out;
              transform: scale(1.2);
            }

            .left-item-img-wra {
              border: #205980 solid 3px;
            }

            .left-item-name-txt {
              color: green;
            }
          }

        }

      }

      .xinwen-right-wrap {
        display: flex;
        flex-direction: column;
        width: 338px;

        .right-top-header {
          background-color: #255C7E;
          height: 100px;
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;

          .rrrr-img {
            width: 30px;
            margin-left: 20px;
          }

          .rrrr-txt {
            font-size: 20px;
            color: white;
            font-weight: 600;
            margin-left: 5px;
          }
        }

        .gongsidongt-item-wrap {
          display: flex;
          flex-direction: row;
          background-color: #DFE0E1;
          width: 100%;
          margin-top: 10px;

          .data-wrap {
            display: flex;
            flex-direction: column;
            height: 84px;

            .day-txt {
              color: #333333;
              font-size: 18px;
              font-weight: 600;
              height: 40px;
              line-height: 40px;
              text-align: center;
              width: 80px;
              background-color: #9BC8E4;
            }

            .month-txt {
              height: 26px;
              line-height: 26px;
              text-align: center;
              font-size: 16px;
              color: #333333;
              background-color: #83BCDD;
            }
          }

          .rich-txt {
            font-size: 14px;
            color: #333333;
            margin-left: 16px;
            margin-top: 16px;
            margin-right: 16px;
          }
        }

        .gongsidongt-item-wrap:hover {
          background-color: #999999;
          cursor: pointer;

          .rich-txt {
            color: white;
          }

          .day-txt {
            color: white;
          }

          .month-txt {
            color: white;
          }
        }

        .ckmore-txt {
          width: 100%;
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;

          .a {
            font-size: 16px;
            color: #666666;
          }

          .a:hover {
            cursor: pointer;
            color: #22B5A8;
            text-decoration: underline;
          }
        }
      }
    }
  }

  .lxwomen {
    width: 100vw;
    height: 370px;
    min-width: 1400px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f2f2f2;

    .lxwo-wrap {
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .lxwo-left-wrap {
        display: flex;
        flex-direction: column;
      }

      .lxwo-right-wrap {
        width: 565px;
        height: 305px;
        border-radius: 3px;
        border: #D0E2FF solid 3px;

      }
    }
  }
}

</style>
